import {Component, OnInit} from '@angular/core';
import {AccountsService} from "../../../services/accounts.service";
import {AlertService} from "../../../services/alert.service";
import {LoaderService} from "../../../services/loader.service";
import {Router} from "@angular/router";
import {Subject} from "rxjs/Rx";
import * as $ from 'jquery';
import {PrintService} from "../../../services/print.service";

@Component({
  selector: 'app-accounts-list',
  templateUrl: './accounts-list.component.html',
  styleUrls: ['./accounts-list.component.css']
})
export class AccountsListComponent implements OnInit {
  private loading = false;
  private accountList;
  dtTrigger:Subject<any> = new Subject();
  dtOptions:any = {};
  authWindow = null;

  constructor(private accountsService:AccountsService,
              private alertService:AlertService,
              private printService:PrintService,
              private router:Router,
              private loaderService:LoaderService) {
  }

  ngOnInit() {
    this.loaderService.loading(true);
    this.dtOptions = {
      select: true,
      buttons: [
        'columnsToggle',
        'colvis',
        'copy',
        'print',
        'excel',
        {
          text: 'Some button',
          key: '1',
          action: function (e, dt, node, config) {
            alert('Button activated');
          }
        }
      ]
    };

    this.accountsService
      .list()
      .subscribe(
        data => {
          this.accountList = data;
          this.initDataTable()
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.loaderService.loading(false);
        });
  }

  initDataTable() {
    $(document).ready(()=> {
      var table:any = $('table');
      table.dataTable();
      this.loaderService.loading(false);
    })
  }

  goToAccountDetails(id:number) {
    this.router.navigate(['/accounts', id]);
  }

  print() {
    this.printService.generate_pdf_file()
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/accounts/accounts-list/accounts-list.component.ts